module.exports = __webpack_public_path__ + "static/media/tutorial-skill-check.1e4ef49d.png";